export const UPDATE_USERS_DATA = 'UPDATE_USERS_DATA'
export const UPDATE_USERS_COUNT = 'UPDATE_USERS_COUNT'
export const UPDATE_SEARCH_WORDS = 'UPDATE_SEARCH_WORDS'
export const UPDATE_CURRENT_PAGE = 'UPDATE_CURRENT_PAGE'
export const RESET_CURRENT_PAGE = 'RESET_CURRENT_PAGE'
export const UPDATE_IS_MANAGER = 'UPDATE_IS_MANAGER'



// WEBPACK FOOTER //
// ./src/store/types.js